<template>
    <div class="phonemodal-wrap" v-if="show">
        <div class="modal">
            <img class="close-btn" :src="require('../../../assets/icon-address-close.png')" @click="handleClose" />
            <div class="text">
                为保障您的账户安全，请根据以下步骤验证您的身份
            </div>
            <div class="input-controller">
                <input class="input-single" type="number" placeholder="请输入您的手机号码" v-model="phone">
            </div>
            <div class="input-controller">
                <input class="input-half" type="number" maxlength="4" placeholder="请输入右侧图形验证码" v-model="captchaCode">
                <a class="captcha-btn" title="点击刷新" @click="refreshCaptcha">
                    <img v-if="captchaImage" :src="captchaImage"/>
                </a>
            </div>
            <div class="input-controller">
                <input class="input-half" type="number" maxlength="6" placeholder="请输入短信验证码" v-model="code">
                <a class="send-captcha-btn" @click="doSendCode" v-if="countDown <= 0">发送验证码</a>
                <a class="send-captcha-btn disable" v-else>重试({{countDown}}s)</a>
            </div>
            <div class="actions">
                <button class="action-btn" @click="doSubmit">提交</button>
            </div>
        </div>
        <div class="mask"></div>
    </div>
</template>

<script>

import api from "../../../api";

const DefaultCountDown = 60
var timer

export default {
  props: [],
  data() {
    return {
      show: false,
      captchaId: '',
      captchaImage: '',
      captchaCode: '',
      code: '',
      phone: '',
      countDown: 0
    };
  },
  methods: {
    doCountDown(){
        clearInterval(timer)
        this.countDown = DefaultCountDown
        timer = setInterval(()=>{
            this.countDown --
            if(this.countDown <= 0){
                clearInterval(timer)
                this.refreshCaptcha()
            }
        }, 1000)
    },
    refreshCaptcha(){
        api.user.getPhoneValidCaptcha(res=>{
            console.log(res)
            this.captchaId = res.id
            this.captchaImage = res.imageData
        })
    },
    handleClose() {
        this.show = false
        clearInterval(timer)
    },
    display() {
      this.show = true
      this.captchaId = ''
      this.captchaImage = ''
      this.countDown = 0
      this.code = ''
      this.refreshCaptcha()
    },
    doSendCode(){
        if(this.captchaId){
            if(!this.phone){
                this.$toast('请填写手机号码')
                return 
            }
            if(!this.captchaCode){
                this.$toast('请填写图形验证码')
                return 
            }
            api.user.getPhoneValidSendVerifyCode(this.captchaId, this.captchaCode, this.phone, res=>{
                console.log(res)
                this.doCountDown()
            }, res=>{
                this.$toast(res.msg)
                this.refreshCaptcha();
            })
        }
        
    },
    doSubmit(){
        api.user.bindPhone(this.phone, this.code, res=>{
            console.log(res)
            this.handleClose()
            this.$toast('完成手机验证，可以继续操作了')
        }, res=>{
            this.$toast(res.msg)
        })
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.phonemodal-wrap {
  .modal {
    position: fixed;
    top: 50%;
    left: 50%;
    background: #fff;
    border-radius: 2vw;
    width: 90vw;
    transform: translate(-50%, -50%);
    z-index: 1001;

    .close-btn {
      @size: 4vw;
      display: inline-block;
      position: absolute;
      top: 4vw;
      right: 4vw;
      width: @size;
      height: @size;
    }

    .text{
        font-size: 3.45vw;
        color: #333;
        line-height: 2em;
        width: 95%;
        margin: 12vw auto 6vw;
        text-align: center;
    }

    .input-controller{
        padding: 2vw 4vw 4vw;

        input{
            display: inline-block;
            border: none;
            border-bottom: 1px solid #bbb;
            font-size: 3.47vw;
            color: #333;
            line-height: 2em;
            padding: 0 2vw;
        }

        .input-single{

            width: 90%;
        }

        .input-half{
            width: 60%;
        }

        .captcha-btn{
            display: inline-block;
            width: 30%;
            margin-left: 2%;
            text-align: center;

            img{
                max-width: 100%;
                max-height: 100%;
                vertical-align: bottom;
            }
            
        }

        .send-captcha-btn{
            display: inline-block;
            width: 30%;
            margin-left: 2%;

            background-image: linear-gradient(to right, #ff0d33, #ff7f5f);
            color: #fff;
            line-height: 3em;
            font-size: 3vw;
            border: none;
            border-radius: 1.5em;
            text-align: center;

            &.disable{
                background-image: linear-gradient(to right, #ccc, #ddd);
            }
        }


    }

    .actions{
        padding: 4vw;

        .action-btn{
            background-image: linear-gradient(to right, #ff0d33, #ff7f5f);
            color: #fff;
            height: 12vw;
            width: 92%;
            line-height: 12vw;
            font-size: 4.26vw;
            border: none;
            display: block;
            margin: 2.53vw auto;
            border-radius: 6vw;

            &.disable{
                background-image: linear-gradient(to right, #666, #888);
            }
        }

    }
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background: #000;
    opacity: 0.6;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/Modal/PhoneModal.vue